import { TableBlockModel, TableModelFlavour } from '@blocksuite/affine-model';
import {
  ActionPlacement,
  type ToolbarAction,
  type ToolbarModuleConfig,
  ToolbarModuleExtension,
} from '@blocksuite/affine-shared/services';
import { TableIcon } from '@blocksuite/icons/lit';
import { BlockFlavourIdentifier } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';

import { convertTableToRichTable } from '../commands/convert-table.js';

/**
 * Adds a one-way "Turn into rich table" action to the plain table's toolbar.
 *
 * Lives in this package rather than the table's so the table block keeps no
 * dependency on the fork-only rich table — it stays untouched by this feature
 * except for gaining this entry.
 */
const convertToolbarConfig = {
  actions: [
    {
      placement: ActionPlacement.More,
      id: 'c.turn-into-rich-table',
      label: 'Turn into rich table',
      icon: TableIcon(),
      run(ctx) {
        const model = ctx.getCurrentModelByType(TableBlockModel);
        if (!model) return;

        const tableId = convertTableToRichTable(ctx.store, model);
        if (!tableId) return;

        ctx.select('note');
        ctx.reset();
      },
    } satisfies ToolbarAction,
  ],
} as const satisfies ToolbarModuleConfig;

export const RichTableConvertToolbarExtension: ExtensionType =
  ToolbarModuleExtension({
    id: BlockFlavourIdentifier(TableModelFlavour),
    config: convertToolbarConfig,
  });
